import { PrescriberContactData } from './../../model/requests-model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import {
  FORM_AUTO,
  FORM_BP,
  FORM_CONSUMO,
  FORM_MG,
  FORM_MG_NO_SHOP,
  PENDIENTES_DE_DATOS,
  PRESCRIBER_CONTACT_DATA,
  REQUEST_MODE_EDIT,
  REQUEST_MODE_NEW,
  REQUEST_MODE_VIEW,
} from '@app/@core/constants/requests.constants';
import { CustomValidatorsService } from '@app/@shared/custom-validators/custom-validators.service';
import { RequestsSaveSendStore } from '@app/requests/requests-save-send-service/requests-save-send.store';
import { CommonDataDTO, VendorComboDTO } from '@app/requests/model/combos-model';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { StatesFieldsFrontDTO } from '@app/requests/model/requests-model';

@Component({
  selector: 'scf-prescriber-contact-data',
  templateUrl: './prescriber-contact-data.component.html',
  styleUrls: ['./prescriber-contact-data.component.scss'],
})
export class PrescriberContactDataComponent implements OnInit {
  @Input() mode: string = REQUEST_MODE_NEW;
  @Input() request: any = null;
  @Input() state: CommonDataDTO;
  @Input() isAutos: boolean = false;
  @Input('vendor') set vendorData(data: any) {
    if (data) {
      this.getVendorData(data);
    } else {
      this.prescriberDataForm?.controls?.prescriberName.setValue('');
      this.prescriberDataForm?.controls?.prescriberPhone.setValue('');
      this.prescriberDataForm?.controls?.prescriberMail.setValue('');
    }
  }
  @Input() operative: string = '';

  @Output() public isFinishedLoading = new EventEmitter<any>();
  @Output() public changeContinueStatus = new EventEmitter<any>();

  public prescriberDataForm: FormGroup;
  public oldPrescriberData: PrescriberContactData;
  private firstLoad: boolean = true;

  //PE_725 Fenix
  fieldsDisabled: StatesFieldsFrontDTO[];

  constructor(
    private formBuilder: FormBuilder,
    private requestStore: RequestsSaveSendStore,
    private customValidators: CustomValidatorsService,
    private translateService: TranslateService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.prescriberDataForm = this.formBuilder.group({
      prescriberName: ['', [Validators.maxLength(50)]],
      prescriberPhone: [{ value: '', disabled: true }, [this.customValidators.isTelephoneValid]],
      prescriberMail: [{ value: '', disabled: true }, [Validators.maxLength(60), this.customValidators.validateEmail]],
    });

    const form = this.prescriberDataForm.controls;

    if (this.requestStore.getMarcaFormulario() === FORM_BP) {
      this.requestStore.setFormularioBonpreu(this.prescriberDataForm, PRESCRIBER_CONTACT_DATA);
    } else if (this.requestStore.getMarcaFormulario() === FORM_MG_NO_SHOP) {
      this.requestStore.setFormularioMangoNoShopping(this.prescriberDataForm, PRESCRIBER_CONTACT_DATA);
    } else if (this.requestStore.getMarcaFormulario() === FORM_MG) {
      this.requestStore.setFormularioMg(this.prescriberDataForm, PRESCRIBER_CONTACT_DATA);
    } else if (this.requestStore.getMarcaFormulario() === FORM_AUTO) {
      this.requestStore.setFormularioAutos(this.prescriberDataForm, PRESCRIBER_CONTACT_DATA);
    } else if (this.requestStore.getMarcaFormulario() === FORM_CONSUMO) {
      this.requestStore.setFormularioConsumo(this.prescriberDataForm, PRESCRIBER_CONTACT_DATA);
    }

    if (this.mode !== REQUEST_MODE_NEW) {
      this.setValuesToForm();
      if (this.mode === REQUEST_MODE_EDIT) {
        if (!this.isAutos) {
          this.onPrescriberNameChanges();
        } else {
          this.onPrescriberNameChangesAutos();
        }
      }
    }

    if (this.mode !== REQUEST_MODE_VIEW) {
      form.prescriberName.valueChanges.subscribe(() => {
        if (!this.isAutos) {
          this.onPrescriberNameChanges();
        } else {
          this.onPrescriberNameChangesAutos();
        }
      });
    }

    this.prescriberDataForm.statusChanges.subscribe(() => {
      if (this.prescriberDataForm) {
        this.changeContinueStatus.emit({ form: <FormGroup>this.prescriberDataForm, id: PRESCRIBER_CONTACT_DATA });
      }
    });

    this.isFinishedLoading.emit({ formID: PRESCRIBER_CONTACT_DATA, value: true });
  }

  private getVendorData(data: VendorComboDTO) {
    const form = this.prescriberDataForm.controls;
    if (
      this.mode === REQUEST_MODE_EDIT &&
      this.firstLoad &&
      this.request.prescriberMail?.length > 0 &&
      this.request.prescriberPhone?.length > 0
    ) {
      form.prescriberName.setValue(this.request.prescriberName);
      form.prescriberMail.setValue(this.request.prescriberMail);
      form.prescriberPhone.setValue(this.request.prescriberPhone);
      this.firstLoad = false;
    } else {
      this.request?.prescriberName
        ? form.prescriberName.setValue(this.request.prescriberName)
        : form.prescriberName.setValue(data.prescriberName);
      this.request?.prescriberMail
        ? form.prescriberMail.setValue(this.request.prescriberMail)
        : form.prescriberMail.setValue(data.prescriberMail);
      this.request?.prescriberPhone
        ? form.prescriberPhone.setValue(this.request.prescriberPhone)
        : form.prescriberPhone.setValue(data.prescriberPhone);
    }
  }

  private onPrescriberNameChanges() {
    const form = this.prescriberDataForm.controls;
    if (this.isFieldValid(form.prescriberName)) {
      form.prescriberPhone.enable();
      form.prescriberMail.enable();
    } else {
      form.prescriberPhone.setValue('');
      form.prescriberPhone.disable();
      form.prescriberMail.setValue('');
      form.prescriberMail.disable();
    }
  }

  private onPrescriberNameChangesAutos() {
    if (this.prescriberDataForm.controls['prescriberName'].value === '') {
      this.prescriberDataForm.controls.prescriberPhone.setValidators(null);
      this.prescriberDataForm.controls.prescriberMail.setValidators(null);
      this.prescriberDataForm.controls.prescriberPhone.disable();
      this.prescriberDataForm.controls.prescriberMail.disable();
      this.prescriberDataForm.controls.prescriberMail.setValue('');
      this.prescriberDataForm.controls.prescriberPhone.setValue('');
    } else {
      this.prescriberDataForm.controls.prescriberPhone.setValidators([
        Validators.required,
        this.customValidators.isTelephoneValid,
      ]);
      this.prescriberDataForm.controls.prescriberMail.setValidators([
        Validators.required,
        Validators.maxLength(60),
        this.customValidators.validateEmail,
      ]);
      this.prescriberDataForm.controls.prescriberPhone.enable();
      this.prescriberDataForm.controls.prescriberMail.enable();
    }
  }

  isFieldValid(field: AbstractControl): boolean {
    if (field.disabled) {
      return true;
    }
    return field.value !== null && field.value !== '' && field.valid;
  }

  alphanumericHyphenBackslash(event: any, element: any): boolean {
    const inputForm = typeof element === 'string' ? element : element?.getAttribute('formControlName');
    let value = this.prescriberDataForm.controls[inputForm].value;

    return this.customValidators.alphanumericHyphenBackslash(event.which ? event.which : event.keyCode, value);
  }

  onMobilePhoneBlur(value: any, element: any) {
    this.alphanumericAndSpecialCharacters(value, element);
    if (this.prescriberDataForm.controls.prescriberPhone.errors?.telephoneInvalid) {
      this.prescriberDataForm.controls.prescriberPhone.setValue('');
    }
  }

  showPopUpEmail() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '600px';
    dialogConfig.data = {
      title: this.translateService.instant('prescriberContactData.title'),
      text: this.translateService.instant('prescriberContactData.popupInfo'),
      icon: 'icon-ic_warning',
    };
    this.dialog.open(ResponseDialogComponent, dialogConfig);
  }

  alphanumericAndSpecialCharacters(value: any, element: any) {
    const inputForm = typeof element === 'string' ? element : element?.getAttribute('formControlName');
    let inputValue = typeof value === 'string' ? value : value?.target.value;
    this.prescriberDataForm.controls[inputForm].setValue(
      this.customValidators.validateAlphanumericAndSpecialChars(inputValue)
    );
  }

  lettersOnly(event: any): boolean {
    return this.customValidators.lettersOnly(event.which ? event.which : event.keyCode);
  }

  setValuesToForm() {
    if (this.request) {
      this.prescriberDataForm.controls.prescriberName.setValue(this.request.prescriberName);
      this.prescriberDataForm.controls.prescriberPhone.setValue(this.request.prescriberPhone);
      this.prescriberDataForm.controls.prescriberMail.setValue(this.request.prescriberMail);
      if (
        this.mode === REQUEST_MODE_VIEW &&
        (this.state.id !== PENDIENTES_DE_DATOS || (this.state.id === PENDIENTES_DE_DATOS && this.operative === 'EIC'))
      ) {
        this.prescriberDataForm.controls.prescriberName.disable();
        this.prescriberDataForm.controls.prescriberPhone.disable();
        this.prescriberDataForm.controls.prescriberMail.disable();
      }
    }
  }

  ngAfterContentChecked() {
    //PE_725 Fenix
    if (this.mode === REQUEST_MODE_EDIT && this.request !== null && this.request.fieldsDisable !== null) {
      this.fieldsDisabled = this.request.fieldsDisable;
      this.disableFieldsByCore();
    }
  }

  private disableFieldsByCore() {
    if (this.fieldsDisabled !== null && this.fieldsDisabled !== undefined) {
      const form = this.prescriberDataForm;
      this.fieldsDisabled.forEach((field) => {
        const toDisable = form.get(field.campoName);
        if (toDisable !== null && toDisable !== undefined) {
          toDisable.disable();
        }
      });
    }
  }
}
